// extracted by mini-css-extract-plugin
export default {"modalContainer":"ErrorModal_modalContainer__dmhvq","modal":"ErrorModal_modal__G-9jU","titleContainer":"ErrorModal_titleContainer__cvbgO"};